var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"c-document-files"},_vm._l((_vm.data),function(item){return _c('div',{key:item.key},[_c('c-document-row',{attrs:{"data":item}})],1)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }